import { useHistory } from 'react-router-dom';
import { Button, Fade } from '@mui/material';
import { makeStyles } from '@mui/styles';

import AuthLayout from 'layouts/auth-layout';

import Banner from './components/banner';
import StartForm from './components/start-form';

const useStyles = makeStyles(() => ({
  button: {
    marginLeft: '10px',
  },
}));

const StartPage = () => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <AuthLayout>
      <Fade in={true}>
        <div>
          <Banner />
          <StartForm />
          <div style={{ textAlign: 'center', marginTop: '50px', marginBottom: '60px' }}>
            <Button type="submit" variant="contained" color="secondary">
              Next
            </Button>
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={() => history.push('/home')}
            >
              Back to home
            </Button>
          </div>
        </div>
      </Fade>
    </AuthLayout>
  );
};

export default StartPage;
